import React from 'react';
import { useTranslation } from 'react-i18next';

import * as constants from '@/constants';
import { Message } from '@/components/shared/Message';
import * as styles from './Warning.module.scss';

export const Warning: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Message colorType="negative" className={styles.root}>
      <div className={styles.header}>
        {t('text.subscription.cancellationDeadline.title')}
      </div>
      <p className={styles.message}>
        {t('text.subscription.cancellationDeadline.body', {
          num: constants.INTERVAL_BUSINESS_DAYS + 1,
        })}
      </p>
    </Message>
  );
};
